import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { isMobile } from "react-device-detect";

import { IRootState } from "../store";

type State = {
  isNavbarClosed: boolean;
  isSearching: boolean;
  isCurrentlyImporting: boolean;
  showFooter: boolean;
  topToPage: {
    value: number;
    tailwindString: string;
  };
};

const initialState: State = {
  isNavbarClosed: isMobile,
  isSearching: false,
  isCurrentlyImporting: false,
  showFooter: true,
  topToPage: {
    value: 48,
    tailwindString: "top-12",
  },
};

const globalStateSlice = createSlice({
  name: "globalState",
  initialState,
  reducers: {
    toggleSearching(state, action: PayloadAction<boolean>) {
      state.isSearching = action.payload;
    },
    toggleNavbarOpen(state, action: PayloadAction<boolean>) {
      state.isNavbarClosed = action.payload;
    },
    setIsCurrentlyImporting(state, action: PayloadAction<boolean>) {
      state.isCurrentlyImporting = action.payload;
    },
    setShowFooter(state, action: PayloadAction<boolean>) {
      state.showFooter = action.payload;
    },
    setTopToPage(
      state,
      action: PayloadAction<{ value: number; tailwindString: string }>,
    ) {
      state.topToPage = action.payload;
    },
  },
});

export const globalStateSelector = (state: IRootState) =>
  state.globalStateReducer;

export const topToPageSelector = (state: IRootState) =>
  state.globalStateReducer.topToPage;

export const {
  toggleNavbarOpen,
  toggleSearching,
  setIsCurrentlyImporting,
  setShowFooter,
  setTopToPage,
} = globalStateSlice.actions;
export default globalStateSlice.reducer;
